//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import ScaleIcon from '@mui/icons-material/Scale';

import ReporteDespachoService from '../ReporteDespacho/ReporteDespachoService'

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'semana_Id';

export default function Semanas_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'nombre',
            headerName: intl.formatMessage({ id: 'Nombre' }),
            editable: false,
            flex: 0.5,
            hide: true
        },
        {
            field: 'year',
            headerName: intl.formatMessage({ id: 'Year' }),
            editable: false,
            flex: 0.5,
        },
        {
            field: 'week',
            headerName: intl.formatMessage({ id: 'Week' }),
            editable: false,
            flex: 0.5,
        },
        {
            field: 'contenedores',
            headerName: intl.formatMessage({ id: 'Contenedores' }),
            editable: false,
            width: 120,
        },
        {
            field: 'paletizados',
            headerName: intl.formatMessage({ id: 'Paletas' }),
            editable: false,
            width: 120,
        },
        {
            field: 'estado',
            headerName: intl.formatMessage({ id: 'Estado' }),
            editable: false,
            width: 140,
            renderCell: (params) => {
                var estado = params.row['estado'];
                var color = estado == "Pendiente" ? "danger" : "success";
                return (
                    <Button color={color} onClick={() => {
                        props.estado_onclick(params.row)
                    }}>
                        {params.row['estado']} <EditIcon />
                    </Button>
                )
            }
        },
        {
            field: 'vaporesSemanales',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 240,
            renderCell: (params) => {
                var estado = params.row['estado'];
                var disabled = estado == "Cerrada";
                return (
                    <div>
                        {!disabled ?
                            <div>
                                <Tooltip arrow placement="top" title={intl.formatMessage({ id: 'Archivos' })}>
                                    <IconButton className="SoftOrangeButton GridButton" onClick={() => {
                                        navigate('/Semanas/' + params.row[keyField] + '/PaletizadosArchivos');
                                    }}>
                                        <DriveFolderUploadIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Vapores" })}>
                                    <IconButton className="DarkTealButton GridButton" onClick={() => {
                                        navigate('/Semanas/' + params.row[keyField] + '/VaporesSemanalesProveedor');
                                    }}>
                                        <DirectionsBoatIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow placement="top" title={intl.formatMessage({ id: "VariantiSemanal" })}>
                                    <IconButton className="DarkBlueButton GridButton" onClick={() => {
                                        navigate('/Semanas/' + params.row[keyField] + '/PaletizadosVariantes');
                                    }}>
                                        <AppsRoundedIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip arrow placement="top" title={intl.formatMessage({ id: "ReporteDePesos" })}>
                                    <IconButton className="BurntSiennaButton GridButton" onClick={() => {
                                        navigate('/Semanas/' + params.row[keyField] + '/ReportePesos');
                                    }}>
                                        <ScaleIcon />
                                    </IconButton>
                                </Tooltip>
                            </div> : <div />
                        }
                    </div>
                    
                )
            },
        },
        //{
        //    field: 'reporteDespacho',
        //    headerName: '',
        //    sortable: false,
        //    editable: false,
        //    filterable: false,
        //    align: 'center',
        //    width: 200,
        //    renderCell: (params) => {
        //        return (
        //            <Button className="DarkTealButton" onClick={() => {
        //                new ReporteDespachoService().ReporteDespacho(params.row[keyField]);
        //            }}>
        //                <DirectionsBoatIcon /> {intl.formatMessage({ id: 'Reporte Despacho' })}
        //            </Button>
        //        )
        //    },
        //},
    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        semana_Id: false,
        nombre: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col">
                        
                    </div>
                </div>
            </Toolbar>
            <Box sx={{
                height: 600, width: 1000,
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
